import {useMutation, useQuery} from '@tanstack/react-query';
import axios from 'axios';

import {RQ_EXCEL_UPLOAD} from '../apis/constants';

import AppConfig from './../../configs/AppConfig';

export const RQExcelUpload = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_upload_excel'],
    mutationFn: async ({token, formData}) => {
      if (!formData || !(formData instanceof FormData)) {
        throw new Error('formData must be an instance of FormData');
      }

      const response = await axios.post(
        `${AppConfig.API_BASE_URL}/${RQ_EXCEL_UPLOAD.url}`,
        formData,
        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        },
      );

      return response.data;
    },
    onSuccess: options.onSuccess,
    onError: options.onError,
  });
};
